import { useState } from 'react'

import declareContext from './declareContext.js'

const defineProperties = () => {
  const [captchaConfig, setCaptchaConfig] = useState({})
  return {
    captchaConfig,
    setCaptchaConfig,
  }
}

const CaptchaConfigContext = declareContext(defineProperties)

const useCaptchaConfigContext = CaptchaConfigContext.useContext
const CaptchaConfigProvider = CaptchaConfigContext.Provider

export { CaptchaConfigProvider, useCaptchaConfigContext }
